import { render } from "./SingleTtrRegistry.vue?vue&type=template&id=55abae32&scoped=true"
import script from "./SingleTtrRegistry.vue?vue&type=script&lang=js"
export * from "./SingleTtrRegistry.vue?vue&type=script&lang=js"

import "./SingleTtrRegistry.vue?vue&type=style&index=0&id=55abae32&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55abae32"]])

export default __exports__